<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-2">
            <label for="fromDate">From Date</label>
            <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label for="toDate">To Date</label>
            <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
          </div>
          <!-- <label for="voucher" class="col-sm-1 control-label">Voucher</label> -->
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button @click.prevent="searchJournal" class="p-button p-component addNewBtn btn-btm-0" label="Search"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button v-if="this.journalBookLists.length > 0" @click.prevent="reset"
                    class="p-button-raised" label="Reset"/>
          </div>
        </div>
      </form>
      <a href="#" @click.prevent="exportCSV()" class="p-field p-col-12 p-md-1" v-if="this.journalBookLists.length > 0">
        <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
      </a>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
          <DataTable :value="journalBookLists"
                     :paginator="true" ref="po"
                     :rowsPerPageOptions="[100,500,1000]"
                     :rows="100" :filters="filters"
                     class="p-datatable-responsive p-datatable-gridlines"
                     data-key="id">
            <Column header="S.N">
              <template #body="sl">
                {{ sl.index + 1 }}
              </template>
            </Column>
            <Column
              header="Miti" :sortable="true"
              field="" filterMatchMode="contains">
              <template #body="slotProps">
                {{ !slotProps.data.repatedTransaction ? slotProps.data.transactionDateNepali : '' }}
              </template>
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDateNepali']"/>
              </template>
            </Column>
            <Column header="Date" :sortable="true" field="transactionDate"
                    filterMatchMode="contains">
              <template #body="slotProps">
                {{ !slotProps.data.repatedTransaction ? slotProps.data.transactionDate : '' }}
              </template>
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDate']"/>
              </template>
            </Column>
            <Column header="VouType" :sortable="true" field="entryType" filterMatchMode="contains">
              <template #body="slotProps">
                {{ !slotProps.data.repatedTransaction ? slotProps.data.entryType : '' }}
              </template>
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['entryType']"/>
              </template>
            </Column>
            <Column header="Voucher" :sortable="true" field="voucher" filterMatchMode="contains">
              <template #body="slotProps">
                {{ !slotProps.data.repatedTransaction ? slotProps.data.voucher : '' }}
              </template>
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['Voucher']"/>
              </template>
            </Column>
            <Column header="Account" :sortable="true"
                    field="accountName" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['accountName']"/>
              </template>
            </Column>
            <Column header="Debit" field="debitBalance" :sortable="true" style="text-align: right"
                    filterMatchMode="contains" bodyStyle="color:#00a65a;text-align: right">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['debitBalance']"/>
              </template>
            </Column>
            <Column header="Credit" field="creditBalance" :sortable="true"
                    filterField="creditBalance" filterMatchMode="contains"
                    bodyStyle="color:#dd4b39;text-align: right">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['creditBalance']"/>
              </template>
            </Column>
            <template #empty>No record found</template>
            <Column header="Action" headerStyle="width: 11em">
              <template #body="slotProps">

                <!-- Edit Button -->
                <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                        v-if="renderIf(slotProps.data) && !slotProps.data.repatedTransaction"
                        @click="editJournalBook(slotProps.data)" disabled/>
                <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                        v-if="!renderIf(slotProps.data) && !slotProps.data.repatedTransaction"
                        @click="editJournalBook(slotProps.data)"/>
                <!-- Edit Button -->
                <!-- Delete Button -->
                <Button icon="pi pi-trash" class="p-button-raised p-button-danger"
                        v-if="renderIf(slotProps.data) && !slotProps.data.repatedTransaction"/>
                <Button icon="pi pi-trash" class="p-button-raised p-button-danger"
                        v-if="!renderIf(slotProps.data) && !slotProps.data.repatedTransaction" disabled/>
                <!-- Delete Button -->
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import DatePicker from 'vue2-datepicker'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'

export default {
  name: 'dayBook',
  data() {
    return {
      name: '',
      fromDate: null,
      toDate: null,
      journalBookLists: [],
      account: 0,
      loading: false,
      columnList: '',
      filters: {},
      englishDateEnabled: true
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
  },
  methods: {
    async searchJournal() {
      let journal = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        accountMasterId: 0
      }
      this.loading = true
      let resp = await this.$store.dispatch('loadDayBookList', journal)
      this.loading = false
      if (resp.data.data.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
      this.journalBookLists = resp.data.data
    },
    editJournalBook(data) {
      let journalEdit = {
        tranId: data.tranId,
        tranModuleType: data.tranModuleType
      }
      if (data.entryType === 'jou') {
        this.$router.push({name: 'Journal Entry', params: {journal: journalEdit}})
      } else if (data.entryType === 'rec') {
        this.$router.push({name: 'Receipt Entry', params: {receipt: journalEdit}})
      } else if (data.entryType === 'pay') {
        this.$router.push({name: 'Payment Entry', params: {payment: journalEdit}})
      }
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList,
        accountMasterId: 0
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccounting/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/dayBookWithOutCash' + '/' + this.$store.getters.fyId + '/' + data.columnList + '/' + data.accountMasterId + '/All',
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'dayBookWithOutCash.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    renderIf(data) {
      if (data.entryType === 'purInvoice' || data.entryType === 'purOrder' || data.entryType === 'purChallan' || data.entryType === 'salesInvoice' || data.entryType === 'salesOrder' || data.entryType === 'salesChallan' || data.entryType === 'purReturn' || data.entryType === 'salesReturn') {
        return true
      }
    },
    reset() {
      // this.journalBookLists = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    }
  },
  components: {
    Dropdown,
    DatePicker,
    Column,
    DataTable,
    InputText,
    InputMask,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// dayBookWithoutCash.vue?07dd0ef9